import { useContext, useEffect, useState } from "react";
import { createPointOfAttention, updatePointOfAttention, deletePointOfAttention, getPointOfAttention, updateMultiplePointOfAttention } from "../services/configurations/pointsOfAttention/pointsofattention";
import { AppContext } from "../context";

type DataResponseType = "DATA" | "ID";
type ActionType = "CREATE" | "UPDATE" | "DELETE" | "UPDATEMULTIPLE";

const handleActionFunction = (action: ActionType, t: Function) => {
  switch (action) {
    case "CREATE":
      return {
        actionFn: createPointOfAttention,
        fnMsg: t("PointsOfAttention.masterApiCreateLabel").replace('tipo ', '').replace('type of', ''),
      };
      case "UPDATE":
        return {
          actionFn: updatePointOfAttention,
          fnMsg: t("Users.usersApiUpdateLabel"),
        };
      case "UPDATEMULTIPLE":
        return {
          actionFn: updateMultiplePointOfAttention,
          fnMsg: t("Users.usersApiUpdateLabel"),
        };
    case "DELETE":
      return {
        // deleteUser service here
        actionFn: deletePointOfAttention,
        fnMsg: t("Users.usersApiDeleteLabel"),
      };
    default:
      return {
        actionFn: () => {},
        fnMsg: "",
      };
  }
};

export const usePointOfAttention = (type: DataResponseType) => {
  const {
    t,
    toast,
    appState: { selectedApp },
    setAppState,
  } = useContext(AppContext);
  const [dataPointOfAttention, setDataPointOfAttention] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);

  const reloadFnPointOfAttention = () => {
    setDataPointOfAttention(null);
    setReload((prev) => prev + 1);
  };

  const pointOfAttentionAction = async (action: ActionType, data: any) => {
    const { actionFn, fnMsg } = handleActionFunction(action, t);
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const actionStatus = await Promise.resolve(actionFn(data, selectedApp?.tenantid!, selectedApp?.appid!))
      .then((response) => {
        toast.current.replace({
          severity: "success",
          summary: "",
          detail: `${fnMsg}`,
          life: 3000,
        });
        return "SUCCESS";
      })
      .catch((error) => {
        toast.current.replace({
          severity: "error",
          summary: "",
          detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        });
        return "ERROR";
      });
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
    }));
    return actionStatus;
  };

  useEffect(() => {
    if (type === "DATA") {
      (async function () {
        await Promise.resolve(getPointOfAttention(selectedApp?.tenantid!))
          .then((response) => {
            const serviceResponse = response?.data;
            setDataPointOfAttention(serviceResponse);
          })
          .catch((error) => {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          });
      })();
    }
  }, [toast, reload, type, setAppState]);

  return {
    dataPointOfAttention,
    pointOfAttentionAction,
    reloadFnPointOfAttention,
  };
};